(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__psCardColors) return;
    window.__psCardColors = true;
    // Al tocar un color: mostrar la slide de esa variante (match por media-id ↔ slide-id),
    // marcar seleccionado y actualizar el link del producto a la variante. NO navega.
    document.addEventListener('click', function (e) {
      var item = e.target.closest && e.target.closest('.ps-card-colors__item');
      if (!item) return;
      e.preventDefault();
      e.stopPropagation();
      var strip = item.closest('.ps-card-colors');
      var card = item.closest('product-card') || item.closest('.product-card');
      if (!strip || !card) return;
      var items = strip.querySelectorAll('.ps-card-colors__item');
      for (var i = 0; i < items.length; i++) items[i].classList.remove('is-selected');
      item.classList.add('is-selected');
      var mid = item.getAttribute('data-media-id');
      if (mid) {
        var slides = card.querySelectorAll('.card-gallery slideshow-slide');
        var target = null;
        for (var j = 0; j < slides.length; j++) { if (slides[j].getAttribute('slide-id') === mid) target = slides[j]; }
        if (target) { for (var k = 0; k < slides.length; k++) slides[k].hidden = (slides[k] !== target); }
      }
      var vurl = item.getAttribute('data-variant-url');
      if (vurl) {
        var links = card.querySelectorAll('a[href*="/products/"]');
        for (var l = 0; l < links.length; l++) links[l].setAttribute('href', vurl);
      }
    }, false);
  })();
  } catch(e) { console.error(e); }
})();

})();
